import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  SecureOperationFeedbackService,
  SecureOperationFeedbackState,
} from 'src/app/services/ui/secure-operation-feedback.service';

@Component({
  selector: 'app-secure-operation-feedback',
  templateUrl: './secure-operation-feedback.component.html',
  styleUrls: ['./secure-operation-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecureOperationFeedbackComponent {
  readonly state$ = this.feedback.state$;

  constructor(private readonly feedback: SecureOperationFeedbackService) {}

  onSuccessAnimationEnd(event: AnimationEvent, state: SecureOperationFeedbackState): void {
    if (
      event.target === event.currentTarget &&
      state.phase === 'success'
    ) {
      this.feedback.animationCompleted(state.animationId, 'success');
    }
  }

  onErrorAnimationEnd(event: AnimationEvent, state: SecureOperationFeedbackState): void {
    if (
      event.target === event.currentTarget &&
      state.phase === 'error'
    ) {
      this.feedback.animationCompleted(state.animationId, 'error');
    }
  }
}
